import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $FlagImg = styled.img`
  width: ${spacing(7)};
  height: ${spacing(7)};
  object-fit: contain;
  box-sizing: border-box;
`;
